import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Customer } from 'src/app/models/customer';
import { Paging } from 'src/app/models/page';
import { SalesOrg } from 'src/app/models/sales-org';
import { CustomerService } from 'src/app/services/customer.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { ReportService } from 'src/app/services/report.service';
import { SalesOrgService } from 'src/app/services/sales-org.service';

@Component({
  selector: 'app-customer-balance-record-modal',
  templateUrl: './customer-balance-record-modal.component.html',
  styleUrls: ['./customer-balance-record-modal.component.sass'],
})
export class CustomerBalanceRecordModalComponent implements OnInit {
  public salesOrg: Array<SalesOrg> = [];
  public salesOrgs: Paging<Array<SalesOrg>> = new Paging([]);
  customer: Customer = new Customer();
  customerInformation = '';
  fiscalNumber = '';
  toWhom: string = '';

  constructor(
    private salesOrgService: SalesOrgService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private reportService: ReportService,
    private readonly exceptionSolutionService: ExceptionSolutionService
  ) { }

  async ngOnInit(): Promise<void> {
    this.salesOrgs = (
      await this.salesOrgService.readSalesOrgs().toPromise()
    ).response;
    this.customer = await this.customerService
      .readCustomerByCode(this.route.snapshot.params.id)
      .toPromise();
    this.customerInformation = `[${this.customer.code}] - [${this.customer.fullName}]`;
    this.fiscalNumber = `${this.customer.mainPersonalInfo.fiscalId}`;
  }

  selectSalesOrg(salesOrg: Array<SalesOrg>) {
    console.log(salesOrg);
    console.log(this.salesOrg);
  }

  async handlePrintClick() {
    if (this.toWhom == '') {

      this.exceptionSolutionService.showAlertWithSolution(`Constancia de Saldos`, `Debe de ingresar informacion de dirigido a`);
      return;
    }

    if (this.salesOrg.length <= 0) {
      this.exceptionSolutionService.showAlertWithSolution(`Constancia de Saldos`, `Debe de seleccionar al menos una sociedad`);
    }

    const reports: Array<Blob> = await Promise.all(
      this.salesOrg.map((salesOrg) =>
        this.reportService
          .customerBalanceRecordPdf(
            this.customer.code,
            'Contratos',
            'Cajero',
            this.toWhom,
            0,
            salesOrg.code
          )
          .toPromise()
      )
    );

    await this.reportService.printReports(...reports);
    // for (const salesOrgCode of this.salesOrg) {

    //   reports.push();
    // }
  }
}
